module.exports = __webpack_public_path__ + "img/mastercard.6644d0ee.svg";